import { f as A } from "./index773.mjs";
import { f as C } from "./index743.mjs";
import { t as D } from "./index749.mjs";
import { r as P } from "./index801.mjs";
import { r as _ } from "./index802.mjs";
import { s as O } from "./index803.mjs";
import { o as b } from "./index804.mjs";
import { i as k } from "./index786.mjs";
import { r as w } from "./index805.mjs";
import { r as L } from "./index806.mjs";
var n = A, c = C, $ = D, G = P, H = _, j = O, F = b, B = k.get, K = w, W = L, X = j("native-string-replace", String.prototype.replace), v = RegExp.prototype.exec, h = v, Y = c("".charAt), q = c("".indexOf), z = c("".replace), I = c("".slice), E = function() {
  var g = /a/, i = /b*/g;
  return n(v, g, "a"), n(v, i, "a"), g.lastIndex !== 0 || i.lastIndex !== 0;
}(), T = H.BROKEN_CARET, S = /()??/.exec("")[1] !== void 0, J = E || S || T || K || W;
J && (h = function(i) {
  var e = this, y = B(e), s = $(i), l = y.raw, U, o, N, r, a, R, x;
  if (l)
    return l.lastIndex = e.lastIndex, U = n(h, l, s), e.lastIndex = l.lastIndex, U;
  var d = y.groups, u = T && e.sticky, t = n(G, e), p = e.source, m = 0, f = s;
  if (u && (t = z(t, "y", ""), q(t, "g") === -1 && (t += "g"), f = I(s, e.lastIndex), e.lastIndex > 0 && (!e.multiline || e.multiline && Y(s, e.lastIndex - 1) !== `
`) && (p = "(?: " + p + ")", f = " " + f, m++), o = new RegExp("^(?:" + p + ")", t)), S && (o = new RegExp("^" + p + "$(?!\\s)", t)), E && (N = e.lastIndex), r = n(v, u ? o : e, f), u ? r ? (r.input = I(r.input, m), r[0] = I(r[0], m), r.index = e.lastIndex, e.lastIndex += r[0].length) : e.lastIndex = 0 : E && r && (e.lastIndex = e.global ? r.index + r[0].length : N), S && r && r.length > 1 && n(X, r[0], o, function() {
    for (a = 1; a < arguments.length - 2; a++)
      arguments[a] === void 0 && (r[a] = void 0);
  }), r && d)
    for (r.groups = R = F(null), a = 0; a < d.length; a++)
      x = d[a], R[x[0]] = r[x[1]];
  return r;
});
var sr = h;
export {
  sr as r
};
